import React from 'react'

import { twMerge } from '../../tailwind/merge'
import { Button } from '../button'
import { ButtonIcon } from '../button-icon'
import { HStack } from '../hstack'
import { type ZoomControlsProps } from './ZoomControls.types'

const buttonClassName = 'h-8 w-8 p-1 rounded border-solid'

export function ZoomControls({
    zoomLabel,
    onZoomIn,
    onZoomOut,
    onReset,
    minusIcon,
    plusIcon,
    disabledZoomIn,
    disabledZoomOut,
    zoomInLabel = 'Zoom in',
    zoomOutLabel = 'Zoom out',
    resetLabel = 'Reset zoom',
    className,
}: ZoomControlsProps) {
    return (
        <HStack
            className={twMerge(
                'flex-row items-center gap-1 p-1 rounded-lg bg-background-input border border-solid border-border-subtle',
                className,
            )}
        >
            <Button
                accessibilityLabel={zoomOutLabel}
                onPress={onZoomOut}
                disabled={disabledZoomOut}
                type='secondary'
                className={buttonClassName}
                iconLeft={<ButtonIcon as={minusIcon} size={24} />}
            />
            <Button
                accessibilityLabel={resetLabel}
                onPress={onReset}
                disabled={!onReset}
                type='text'
                className='h-auto w-14 p-1 rounded hover:bg-background-input-hover'
            >
                {zoomLabel}
            </Button>
            <Button
                accessibilityLabel={zoomInLabel}
                onPress={onZoomIn}
                disabled={disabledZoomIn}
                type='secondary'
                className={buttonClassName}
                iconLeft={<ButtonIcon as={plusIcon} size={24} />}
            />
        </HStack>
    )
}
